<template>
  <div id="App">
      <div class="head">
        <!-- 第一层 -->
        <div class="banner">
              <img src="/static/img/pub1.jpg" alt="" class="banner_dimg_s">
              <div class="bnnaer_seach">
                <el-select v-model="value" placeholder="全部" class="my-el-select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-input v-model="input" class="borderNone" placeholder="请输入书号、书名、出版社、作者模糊搜索"></el-input>
                <i class="el-icon-search sousou" @click="sousuo" ></i>

              </div>
          </div>
      </div>

  </div>
</template>
<script>
  export default{
    data(){
      return {
        input: '',
        options: [{
          value: 'tm',
          label: '书号'
        }, {
          value: 'title',
          label: '书名'
        }, {
          value: 'cbs',
          label: '出版社'
        }, {
          value: 'zz',
          label: '作者'
        }, {
          value: 'cbrq',
          label: '出版日期'
        }, {
          value: 'ztfl',
          label: '中图分类'
        }],
        value: '',
      }
    },

   mounted () {
     let index = this.$route.query.index
     this.activeIndex = index
     this.recordapi();
   },
   methods:{
     sou(e){
       this.$router.push('/Products?index=2&keyword='+e)
       this.$emit('sou')
     },
    sousuo(){
      this.$router.push({path:'/Book',query:{type:this.value,keywore:this.input}});
    },


     recordapi(){
         var that = this;
         var userid = that.$cookieStore.getCookie('userid');
         if(userid){
           this.userid = userid;
         }

         that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
           console.log(res);
           that.info= res;
           that.user= res.user;
           that.pieces= res.pieces;
         });
     },

   }

   }
</script>



// WEBPACK FOOTER //
// src/components/public/headfor.vue